// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.search-filter{margin-bottom:20px}.search-filter .search-input{width:330px}`, "",{"version":3,"sources":["webpack://./src/components/common/search-filter/SearchFilter.scss"],"names":[],"mappings":"AAAA,eACC,kBAAA,CACA,6BACC,WAAA","sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
